<div *ngIf="gridData && gridData.length > 0">
  <app-data-grid
    [isQuickView]="true"
    [dataItems]="gridData"
    [group]="group"
    [columnGroups]="columnGroups"
    [columns]="columns"
    [maxHeight]="height"
    [minWidth]="1100"
    [filterable]="'menu'"
    [paginate]="false"
  >
    <ng-template
      commandColumnTemplate
      align="start"
      type="delete"
      [width]="40"
      let-dataItem
    >
      <button
        kendoButton
        (click)="removeRow(dataItem)"
        themeColor="error"
        rounded="full"
        fillMode="flat"
      >
        <fa-icon class="m-r-0" [icon]="['fas', 'circle-x']" size="sm"></fa-icon>
      </button>
    </ng-template>

    <ng-template
      groupColumnHeaderTemplate
      field="tierName"
      let-group="group"
      let-column="column"
    >
      <div class="k-d-flex k-gap-md align-items-center">
        <button
          kendoButton
          size="small"
          themeColor="error"
          (click)="tierToRemoveChanges = group.items[0].tierId"
        >
          Remove all
        </button>
        <span>{{ group.value }} ({{ group.items.length }} changes)</span>
        <kendo-checkbox
          kendoTooltip
          title="Unselecting this checkbox will exclude the tier from the {{
            type
          }} sync"
          [checkedState]="true"
          (checkedStateChange)="toggleSelectedTiers(group.value, $event)"
        >
        </kendo-checkbox>
      </div>
    </ng-template>

    <ng-template
      columnTemplate
      field="deliveryPrice"
      let-row="row"
      let-column="column"
    >
      <p
        *ngIf="row.deliveryPrice == null"
        [style.textAlign]="column.align || 'center'"
        class="m-0 italic-text"
        kendoTooltip
        title="In-store price applied by default"
      >
        {{ row.itemPrice | currency: "USD" }}
      </p>
      <app-column
        [data]="row"
        [column]="column"
        *ngIf="row.deliveryPrice != null"
      >
      </app-column>
    </ng-template>

    <ng-template
      columnTemplate
      field="newAvailability"
      let-row="row"
      let-column="column"
    >
      <app-column
        [data]="row"
        [column]="column"
        *ngIf="row.newAvailability != null"
      >
      </app-column>

      <p class="m-0 italic-text" *ngIf="row.newAvailability == null">No changes</p>
    </ng-template>

    <ng-template
      columnTemplate
      field="newDeliveryAvailability3P"
      let-row="row"
      let-column="column"
    >
      <app-column
        [data]="row"
        [column]="column"
        *ngIf="row.newDeliveryAvailability3P != null"
      >
      </app-column>

      <p class="m-0 italic-text" *ngIf="row.newDeliveryAvailability3P == null">No changes</p>
    </ng-template>

    <ng-template
      columnTemplate
      field="tierName"
      let-row="row"
      let-column="column"
    >
      <div class="k-d-flex">
        <span>{{ row.tierName }}</span>
        <span *ngIf="row.isRealignment">
          <button
            kendoTooltip
            [title]="
              'This change will sync all restaurants in ' +
              row.tierName +
              ' to the king\'s price'
            "
            kendoButton
            class="m-l-4 success-bg badge-button"
            size="small"
            rounded="full"
          >
            Realignment
          </button>
        </span>
      </div>
    </ng-template>
  </app-data-grid>
</div>

<h5 class="m-0 italic-text" *ngIf="!gridData || gridData.length == 0">
  No pending {{ type }} changes
</h5>

<kendo-dialog
  *ngIf="tierToRemoveChanges != null"
  title="Remove {{ type }} changes"
  (close)="tierToRemoveChanges = null"
>
  <div class="unlock-tier-confirmation-message">
    <p>
      This action will remove all pending <strong>{{ type }}</strong> changes.
    </p>

    <p>This action cannot be undone.</p>
    <p>Are you sure you want to proceed?</p>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="tierToRemoveChanges = null">No</button>
    <button kendoButton (click)="onConfirmRemoveChanges()" themeColor="error">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
